import type { HistoryEntry, RecheckOutcome, SourceRelation, TimePrecision } from './models';

export const RELATION_LABEL: Record<SourceRelation, string> = {
  first_report: '최초 보도', follow_up: '추가 보도', update: '수정', correction: '공식 정정', rebuttal: '반박', withdrawal: '철회',
};
export const PRECISION_LABEL: Record<TimePrecision, string> = {
  exact: '날짜와 시각 확인', date_only: '날짜만 확인', unknown: '확인하지 못함',
};
export const RECHECK_LABEL: Record<RecheckOutcome, string> = {
  no_change: '새 정정 없음', new_source: '새 출처 발견', source_unavailable: '출처 접근 불가', check_later: '나중에 다시',
};
export function displayTime(value?: string, precision: TimePrecision = 'exact', missing = '기록 없음'): string {
  if (precision === 'unknown') return '확인하지 못함';
  if (!value) return missing;
  const date = new Date(precision === 'date_only' && /^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T00:00:00` : value);
  if (Number.isNaN(date.getTime())) return '확인하지 못함';
  return precision === 'date_only' ? date.toLocaleDateString('ko-KR') : date.toLocaleString('ko-KR');
}
const FIELD_LABEL: Record<string, string> = {
  publisher: '발행처', url: '주소', publishedAt: '게시', modifiedAt: '수정', relation: '관계',
  timePrecision: '시각 확인 수준', officialCorrectionUrl: '공식 정정 링크', archiveUrl: '보관 사본',
  relatedReceiptId: '연결 기사', text: '메모', label: '묶음 이름', purpose: '목적',
};
function historyValue(key: string, value: string | undefined, values: Record<string, string> | undefined): string {
  if (!value) return '비움';
  if (key === 'relation') return RELATION_LABEL[value as SourceRelation] ?? '확인하지 못함';
  if (key === 'timePrecision') return PRECISION_LABEL[value as TimePrecision] ?? '확인하지 못함';
  if (key === 'purpose') return ({claim:'청구 준비',scrap:'과제·업무 스크랩',watch:'지켜보기'} as Record<string,string>)[value] ?? '확인하지 못함';
  if (key === 'publishedAt') return displayTime(value, values?.timePrecision as TimePrecision | undefined);
  if (key === 'modifiedAt') return displayTime(value);
  if (key === 'relatedReceiptId') return '연결됨';
  return value;
}
export function historyChanges(entry: HistoryEntry): string[] {
  return Object.keys(FIELD_LABEL).filter(key =>
    (key in (entry.before ?? {}) || key in (entry.after ?? {})) && entry.before?.[key] !== entry.after?.[key],
  ).map(key => `${FIELD_LABEL[key]}: ${historyValue(key,entry.before?.[key],entry.before)} → ${historyValue(key,entry.after?.[key],entry.after)}`);
}
